module.exports = __webpack_public_path__ + "media/images/people-a9142597346758e4627a1ac968483336.svg";